module.exports = __webpack_public_path__ + "static/media/bunu02.9644e7b1.gif";